import './AgeGate.css';

interface AgeGateProps {
  isDeclined: boolean;
  onConfirm: () => void;
  onDecline: () => void;
}

export function AgeGate({ isDeclined, onConfirm, onDecline }: AgeGateProps) {
  return (
    <div className="age-gate" role="dialog" aria-modal="true" aria-labelledby="age-gate-title">
      <div className="age-gate__overlay" />
      <div className="age-gate__card">
        <div className="age-gate__logo">Hygh Vybe</div>
        <h1 id="age-gate-title" className="age-gate__title">
          Age Verification
        </h1>

        {isDeclined ? (
          <div className="age-gate__declined">
            <p className="age-gate__message">
              This site is restricted to users 21 years of age or older.
            </p>
            <p className="age-gate__sub-message">
              You are unable to access this site during your current session.
            </p>
          </div>
        ) : (
          <>
            <p className="age-gate__prompt">Are you 21 years of age or older?</p>
            <div className="age-gate__actions">
              <button
                type="button"
                className="age-gate__btn age-gate__btn--confirm"
                onClick={onConfirm}
              >
                Yes, I am 21 or older
              </button>
              <button
                type="button"
                className="age-gate__btn age-gate__btn--decline"
                onClick={onDecline}
              >
                No, I am under 21
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
